import { useNavigate } from "@tanstack/react-router";
import { PageHeader } from "@/components/ui";
import { useUserPermisos } from "@/lib/auth-store";
import { seccionesVisibles } from "../data/secciones";
import { SeccionCard } from "./SeccionCard";

export function AdminHubPage() {
  const navigate = useNavigate();
  // Hotspot 98 · solo las tarjetas de las pantallas que el usuario puede abrir.
  const secciones = seccionesVisibles(useUserPermisos());
  return (
    <div className="mx-auto max-w-7xl px-4 py-8 md:px-6">
      <PageHeader
        title="Administración"
        description="Catálogos y configuración del portal · acceso restringido a administradores."
        breadcrumbs={[
          { label: "Inicio", href: "/dashboard" },
          { label: "Admin" },
        ]}
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {secciones.map((s) => (
          <SeccionCard key={s.href} seccion={s} onClick={() => void navigate({ to: s.href as never })} />
        ))}
      </div>
    </div>
  );
}
